import React from "react";
import { Helmet } from "react-helmet-async";
import {
  SITE_NAME,
  SITE_TITLE_SUFFIX,
  DEFAULT_DESCRIPTION,
  DEFAULT_OG_IMAGE,
  IS_PRODUCTION_SITE,
  absoluteUrl,
} from "./defaults";

const isFacebookSafeImage = (path) => {
  if (!path) return false;
  return !/\.svg(\?.*)?$/i.test(path);
};

const Seo = ({
  title,
  description = DEFAULT_DESCRIPTION,
  canonical,
  ogImage = DEFAULT_OG_IMAGE,
  type = "website",
  jsonLd,
}) => {
  const fullTitle = title
    ? `${title}${SITE_TITLE_SUFFIX}`
    : "Trade Square — AWS Consulting & Data Platforms";
  const canonicalUrl = canonical ? absoluteUrl(canonical) : undefined;
  const safeOgImage = isFacebookSafeImage(ogImage) ? ogImage : DEFAULT_OG_IMAGE;
  const ogImageUrl = absoluteUrl(safeOgImage);
  const jsonLdArray = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {!IS_PRODUCTION_SITE && <meta name="robots" content="noindex,nofollow" />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      {ogImageUrl && <meta property="og:image" content={ogImageUrl} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {ogImageUrl && <meta name="twitter:image" content={ogImageUrl} />}

      {jsonLdArray.map((data, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(data)}
        </script>
      ))}
    </Helmet>
  );
};

export default Seo;
